export default __webpack_public_path__ + "static/media/bihada-factory-mission-06.732738e9.jpg";